module.exports = __webpack_public_path__ + "img/pic_an_xzh@2x.f142eba1.png";